module.exports = __webpack_public_path__ + "static/img/55.1cc11bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/talentService/55.png
// module id = GfAv
// module chunks = 2